module.exports = __webpack_public_path__ + "static/img/section_first_aid_laboratory_bg.c60494e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/section_first_aid_laboratory_bg.png
// module id = 8sMh
// module chunks = 1